import { styled, keyframes } from '@mui/system';
import { Box, Typography } from '@mui/material';

// Animaciones
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Fondo principal
export const BackgroundContainer = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  height: '100vh',
  width: '100%',
  backgroundColor: '#230B41',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  animation: `${fadeIn} 1s ease-in-out`,
  transition: 'opacity 1s ease-in-out',
  '&.fade-out': {
    animation: `${fadeOut} 1s ease-in-out`,
    opacity: 0,
  },
});

// Contenedor del logo superior (con "Tempo")
export const LogoContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  marginBottom: '20px',
  position: 'absolute',
  top: '20px',
  left: '20px',
});

// Texto del título
export const Title = styled(Typography)({
  color: '#FFFFFF',
  fontSize: '17px',
  fontWeight: 'bold',
  margin: 0,
  lineHeight: '22px',
  letterSpacing: '-0.4px',
});

// Contenedor central para el logo animado
export const CenterBox = styled(Box)({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

// Logo animado circular
export const CircleLogo = styled('img')({
  height: '450px', // Tamaño del logo central
  zIndex: 1,
  animation: `${rotateAnimation} 5s linear infinite`, // Animación de rotación
  filter: 'drop-shadow(0 0 20px rgba(100, 0, 255, 0.5))', // Efecto de brillo para simular el prototipo
});
